import { Text, TextProps } from "@chakra-ui/react";
import { FixedNumberDisplay } from "./NumberDisplay";

interface Props extends TextProps {
  price: number;
}

export default function PriceDisplay({ price, ...props }: Props) {
  return (
    <Text {...props}>
      <FixedNumberDisplay decimals={0} number={price} prefix={<>&euro;</>} />
    </Text>
  );
}
